<template>
  <div class="">
    <div class="top"></div>
    <div class="box">
      <div class="img">{{ userInfo.Name.slice(-1) }}</div>
      <div class="name">{{ userInfo.Name }}</div>
      <div class="des">{{ userInfo.EName }}-{{ userInfo.EDName }}</div>

      <van-cell :title="userInfo.Mobile">
        <!-- 使用 right-icon 插槽来自定义右侧图标 -->
        <template #right-icon>
          <van-icon
            @click="callphone(userInfo.Mobile)"
            name="phone-o"
            class="search-icon"
            size="20"
          />
        </template>
      </van-cell>
    </div>
  </div>
</template>

<script>
import { getUserInfoByESId } from "@/api/addressBook";
export default {
  // 组件名称
  name: "",
  // 组件参数 接收来自父组件的数据
  props: {},
  // 局部注册的组件
  components: {},
  // 组件状态值
  data() {
    return {
      userInfo: {},
    };
  },
  // 计算属性
  computed: {},
  // 侦听器
  watch: {},
  // 组件方法
  methods: {
    getUserInfo() {
      getUserInfoByESId({ ESId: this.$route.params.id }).then((res) => {
        if (res.data.code == 0) {
          this.userInfo = res.data.data;
          console.log(this.userInfo);
        }
      });
    },
    callphone(phonenumber) {
      window.location.href = "tel://" + phonenumber;
    },
  },
  created() {},
  mounted() {
    console.log(this.$route.params.id);
    this.getUserInfo();
  },
};
</script> 

<style scoped>
.top {
  width: 100%;
  height: 160px;
  background-color: #397aff;
}

.box {
  width: 100%;
  min-height: 70vh;
  background-color: #fff;
  margin-top: -50px;
  border-radius: 18px 18px 0 0;
  overflow: hidden;
}

.img {
  background-color: #397aff;
  width: 70px;
  height: 70px;
  position: absolute;
  /* top: 0; */
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 50%;
  text-align: center;
  line-height: 70px;
  color: #fff;
  font-family: PingFang SC;
  font-size: 24px;
  border: 2px solid #fff;
}

.name {
  color: #323233;
  font-family: PingFang SC;
  font-size: 20px;
  text-align: center;
  margin-top: 50px;
}

.des {
  color: #333232cf;
  font-family: PingFang SC;
  font-size: 12px;
  text-align: center;
  margin-top: 2px;
}
</style>